export default __webpack_public_path__ + "static/media/image1.42012b37.jpg";